// extracted by mini-css-extract-plugin
module.exports = {"component":"styles-module--component--2syKR","triangle":"styles-module--triangle--2EBpS","green":"styles-module--green--2ZxKC","blue":"styles-module--blue--18ai4"};